
import { httpservice } from '../services';
import { dateFormat } from '../helper/StringUtils';
import { constants } from '../constant/constant';
import {SOFTWARE, EMOTION} from '../constant/actionTypes';

export default function getAccountList(object) {
  let query = constants.API.ACCOUNT;
  if (object && object.id) {
    query = `${constants.API.ACCOUNT}/${object.id}`;
  } else if (object && Object.keys(object).length > 0) {
    const params = new URLSearchParams(object).toString();
    query = `${constants.API.ACCOUNT}?${params}`;
  }
  return httpservice()
    .get(query)
    .then(response => {
      const rows = Array.isArray(response.data.response) ? response.data.response : response.data.response.rows || [];
      const count = Array.isArray(response.data.response) ? response.data.response.length : response.data.response.count || 0;
      const dataArray = rows.map(data => ({
        ...data,
        created_at: data.create_time,
        status: data.account_status,
      }));
      return { data: dataArray, count };
    })
    .catch(error => {
      throw error;
    });
}
